/* lua.js generated code 0.3.0 */
require("clover/utils/GameSpeedManager")
var GameGuideTrigger = require("clover/gameGuide/GameGuideTrigger")
var GameGuideData = require("clover/gameGuide/GameGuideData")
var Guides = null
const GUIDES_CONFIG_PATH = "meta/guides.json"
const GUIDES_CONFIG_PATH_B = "meta/guidesB.json"

var GameGuideCheck = require("clover/gameGuide/GameGuideCheck")
var GameGuideRunner = require("clover/gameGuide/GameGuideRunner")
var Event = require("cocos/framework/components/event")
const { dc4UserLoad } = require("../../entry/dc")
GameGuide = xClass("GameGuide", Event)
GameGuideEvents = table(
    [1, "StartGuide", "GAMEGUIDEEVENTS.STARTGUIDE"],
    [1, "EndGuide", "GAMEGUIDEEVENTS.ENDGUIDE"],
    [1, "StartAction", "GAMEGUIDEEVENTS.STARTACTION"],
    [1, "EndAction", "GAMEGUIDEEVENTS.ENDACTION"],
    [1, "SkipGuide", "GAMEGUIDEEVENTS.SKIPGUIDE"]
)
var guide = null
GameGuide.getInstance = function () {
    if (!guide) {
        guide = GameGuide.new()
    }
    guide.init()
    return guide
}
GameGuide.prototype.ctor = function () {
    var self = this
    self.bind(self)
    GameGuideData.getInstance()
}
GameGuide.prototype.init = function () {
    var self = this
    if (self.inited || self.loading || !UserManager.getInstance().uid) return 
    self.loading = true
    
    let globScale = self.getReferenceScale()
    let replaceProperty = {
        "posRatio_1" : { x: (1 - globScale) * 8.6, y: 0 },
        "posRatio_2" : { x: (globScale - 1) * 6  , y: 0 },
        "posRatio_3" : { x: (globScale - 1) * 6  , y: 0 },
        "posRatio_4" : { x: (globScale - 1) * 5.5, y: 0 }
    }
    let configPath = UserManager.getInstance().isLevelTestGroup() ? GUIDES_CONFIG_PATH_B : GUIDES_CONFIG_PATH

    ResManager.load(configPath)
    .then((result) => {
        var parseTable = function(data, needIdx0 = true){
            var t = table()
            if (needIdx0){
                t[0] = null
            }
            for (var k in data){
                var d = data[k]
                if (typeof(d) == "object"){
                    t[k] = parseTable(d)
                }else{
                    if (d == "globScale"){
                        d = (self.getReferenceScale() - 1) * 5.5
                    }
                    else if(replaceProperty.hasOwnProperty(d))
                    {
                        d = replaceProperty[d]
                    }
                    t[k] = d
                }
            }
            return t
        }
        temp = result[0][0]
        Guides = parseTable(temp, false)
        var data = GameGuideData.getInstance()
        if (__WIN32) {
            GameGuideCheck.verifyGuideConditions(Guides)
        }
        data.setGuides(Guides)
        data.readFromFile()
        self.loading = false
        self.inited = true
    })
    .catch((err) => {
        self.loading = false
        self.inited = false
        cc.log("load Guides failed!", err);
    });
}

GameGuide.prototype.getReferenceScale = function() {
    var vSize = cc.Director.getInstance().getVisibleSize()
    var height = vSize.width * vSize.height / 720
    // WARN: maybe multi result
    return Math.min((700 + height) / 1980, 1)
}

GameGuide.prototype.trigger = function (keyword, paras) {
    var self = this
    if (type(paras) !== "table") {
        paras = sTable()
    }
    self.m_currentTriggerParas = paras
    var data = GameGuideData.getInstance()
    if (data.getProcessing()) {
        return
    }
    data.setProcessing(true)
    GameGuideTrigger.preCheck(keyword, paras)
    self.tryEndCurrentGuide(paras)
    var ret = self.tryRunNewGuide(paras)
    GameGuideTrigger.postRun(keyword, paras)
    data.resetProcessing()
    return ret
}
GameGuide.prototype.forceStop = function () {
    var self = this
    GameGuideData.getInstance().setForceStop(true)
    self.tryEndCurrentGuide()
    // WARN: maybe multi result
    return self.tryRunNewGuide()
}
GameGuide.prototype.tryStart = function () {
    var self = this
    GameGuideData.getInstance().setForceStop(false)
    self.tryEndCurrentGuide()
    // WARN: maybe multi result
    return self.tryRunNewGuide()
}
GameGuide.prototype.isHaveGuideThisLevel = function (levelId) {
    var self = this
    // WARN: maybe multi result
    return self.checkHaveGuide(levelId)
}
GameGuide.prototype.tryRunNewGuide = function (paras) {
    if (_G.isOHOS){
        return
    }
    var self = this
    var data = GameGuideData.getInstance()
    if (data.getRunningGuide()) {
        return false
    }
    data.setGuideIndex(self.getFirstGuide(paras))
    if (data.getRunningGuide()) {
        data.setActionIndex(1)
        GameGuideRunner.runGuide(paras)
        self.dispatchEvent(table(
            [1, "name", GameGuideEvents.StartGuide],
            [1, "guideIndex", data.getGuideIndex()],
            [1, "actionIndex", data.getActionIndex()]
        ))
        self.dispatchEvent(table(
            [1, "name", GameGuideEvents.StartAction],
            [1, "guideIndex", data.getGuideIndex()],
            [1, "actionIndex", data.getActionIndex()]
        ))
        return true
    }
    return false
}
GameGuide.prototype.isGuideRunning = function () {
    var self = this
    var data = GameGuideData.getInstance()
    return data.getRunningGuide() != null
}
GameGuide.prototype.tryEndCurrentGuide = function (paras) {
    var self = this
    var data = GameGuideData.getInstance()
    if (!data.getRunningGuide()) {
        return
    }
    var [willEnd, rec, success] = self.checkDisappear(paras)
    if (willEnd) {
        dc.dcStepOfTutorial_15(tonumber(data.getGuideIndex()) * 100 + tonumber(data.getActionIndex()))
        GameGuideRunner.removeGuide(paras)
        if (rec) {
            if (!data.containInGuidedIndex(data.getGuideIndex())) {
                if (table.size(data.getGuidedIndex()) >= table.size(data.getGuides())) {
                    dc.dcTutorial_3()
                }
            }
            data.incGuidedIndex(data.getGuideIndex())
            data.addToGuideInLevel(data.getGuideIndex())
            data.addToCurLevelGuide(data.getGuideIndex())
        }
        if (success) {
            data.addToCurSuccessGuide(data.getGuideIndex())
            data.incSucceedGuideIndex(data.getGuideIndex())
        }
        var [guideIndex, actionIndex] = [data.getGuideIndex(), data.getActionIndex()]
        data.resetRunningGuide()
        data.resetRunningAction()
        data.writeToFile()
        self.dispatchEvent(table(
            [1, "name", GameGuideEvents.EndAction],
            [1, "guideIndex", guideIndex],
            [1, "actionIndex", actionIndex]
        ))
        self.dispatchEvent(table(
            [1, "name", GameGuideEvents.EndGuide],
            [1, "guideIndex", guideIndex],
            [1, "actionIndex", actionIndex]
        ))
    }
}
GameGuide.prototype.checkHaveGuide = function (level) {
    var self = this
    var data = GameGuideData.getInstance()
    var scene = data.getScene()
    var levelId = data.getLevelId()
    data.setScene("GameScene")
    data.setLevelId(level)
    var $st33 = GameGuideData.getInstance().getGuides()
    for (var k in $st33) {
        var v = $st33[k]
        var list = table(
            [0, table([1, "type", "scene"], [1, "force", true])],
            [0, table([1, "type", "topLevel"])],
            [0, table([1, "type", "onceOnly"])],
            [0, table([1, "type", "curLevelGuided"])],
            // [0, table([1, "type", "weekGameTargetZero"])],
            [0, table([1, "type", "notGuideProp"])],
            [0, table([1, "type", "gamePlayType"], [1, "para", table("kFish")])],
            [0, table([1, "type", "animalCoinShow"])],
            [0, table([1, "type", "scoreAnimalBuff"])],
            [0, table([1, "type", "propBlock"])]
        )
        if (GameGuideCheck.checkFixedAppears(v, list, null, k)) {
            data.setScene(scene)
            data.setLevelId(levelId)
            return true
        }
    }
    data.setScene(scene)
    data.setLevelId(levelId)
    return false
}

GameGuide.prototype.getLevelGuide = function (level) {
    let guides = table()
    var data = GameGuideData.getInstance()
    var scene = data.getScene()
    var levelId = data.getLevelId()
    data.setScene("GameScene")
    data.setLevelId(level)
    var $st33 = GameGuideData.getInstance().getGuides()
    for (var k in $st33) {
        var v = $st33[k]
        var list = table(
            [0, table([1, "type", "scene"], [1, "force", true])],
            [0, table([1, "type", "topLevel"])],
            [0, table([1, "type", "onceOnly"])]
        )
        if (GameGuideCheck.checkFixedAppears(v, list, null, k)) {
            guides.push(v)
        }
    }
    data.setScene(scene)
    data.setLevelId(levelId)
    return guides
}
GameGuide.prototype.checkHaveGuideFixed = function (level, list, guideIds) {
    let self = this
    let data = GameGuideData.getInstance()
    let scene = data.getScene()
    let levelId = data.getLevelId()
    data.setScene("GameScene")
    data.setLevelId(level)
    let $st40 = GameGuideData.getInstance().getGuides()
    for (let k in $st40) {
        let v = $st40[k]
        if ($null(v)) continue
        if (GameGuideCheck.checkFixedAppears(v, list, null, k) && guideIds[k]) {
            data.setScene(scene)
            data.setLevelId(levelId)
            return true
        }
    }
    data.setScene(scene)
    data.setLevelId(levelId)
    return false
}
GameGuide.prototype.getFirstGuide = function (paras) {
    var self = this
    var data = GameGuideData.getInstance()
    if (data.getForceStop() || data.getSkipLevel()) {
        return null
    }
    var $st38 = data.getGuides()
    for (var k in $st38) {
        var v = $st38[k]
        if (GameGuideCheck.checkAppear(v, paras, k)) {
            return parseInt(k, 10)
        }
    }
    return null
}
GameGuide.prototype.checkDisappear = function (paras) {
    var self = this
    var data = GameGuideData.getInstance()
    if (data.getForceStop()) {
        return [true]
    }
    // WARN: maybe multi result
    return GameGuideCheck.checkDisappear(data.getRunningGuide(), paras, data.getGuideIndex())
}
GameGuide.prototype.onGuideComplete = function (skipLevel) {
    var self = this
    var data = GameGuideData.getInstance()
    var step = tonumber(data.getGuideIndex()) * 100 + tonumber(data.getActionIndex())
    dc.dcStepOfTutorial_15(step, true)

    // step.130 新手引导动画完成
    if (_G.kIsNewUser && !_G.fisrtAdviseComplete && ((step == 10202) || (step == 10201 && skipLevel))) {
        _G.fisrtAdviseComplete = true
        dc4UserLoad(130);
    }
    DCAssist.dc4LevelUserOp130(data.getLevelId())
    if (!data.getRunningGuide()) {
        data.resetRunningGuide()
        return
    }

    GameGuideRunner.removeGuide()

    if (skipLevel) {
        data.setSkipLevel(true)
    }
    self.dispatchEvent(table(
        [1, "name", GameGuideEvents.EndAction],
        [1, "guideIndex", data.getGuideIndex()],
        [1, "actionIndex", data.getActionIndex()]
    ))
    var action = data.incRunningAction()
    if (skipLevel || !action) {
        if (!data.containInGuidedIndex(data.getGuideIndex())) {
            if (table.size(data.getGuidedIndex()) >= table.size(data.getGuides())) {
                dc.dcTutorial_3()
            }
        }
        data.incGuidedIndex(data.getGuideIndex())
        data.addToGuideInLevel(data.getGuideIndex())
        data.addToCurLevelGuide(data.getGuideIndex())
        data.addToCurSuccessGuide(data.getGuideIndex())
        data.incSucceedGuideIndex(data.getGuideIndex())
        var [guideIndex, actionIndex] = [data.getGuideIndex(), data.getActionIndex() - 1]
        data.resetRunningGuide()
        data.resetRunningAction()
        data.writeToFile()
        self.dispatchEvent(table(
            [1, "name", GameGuideEvents.EndGuide],
            [1, "guideIndex", guideIndex],
            [1, "actionIndex", actionIndex]
        ))
    } else {
        self.dispatchEvent(table(
            [1, "name", GameGuideEvents.StartAction],
            [1, "guideIndex", data.getGuideIndex()],
            [1, "actionIndex", data.getActionIndex()]
        ))
        GameGuideRunner.runGuide()
    }
}
GameGuide.prototype.onRunReplayGuide = function (index, paras) {
    var self = this
    var data = GameGuideData.getInstance()
    if (!data.getRunningGuide()) {
        data.resetRunningGuide()
        return
    }
    var guide = data.getGuideById(index)
    data.addToGameFlags("replay")
    if (!guide || !GameGuideCheck.checkAppear(guide, paras, index)) {
        return
    }
    data.removeFromGameFlags("replay")
    GameGuideRunner.removeGuide(paras)
    dc.dcStepOfTutorial_15(tonumber(data.getGuideIndex()) * 100 + tonumber(data.getActionIndex()))
    data.incGuidedIndex(data.getGuideIndex())
    data.addToGuideInLevel(data.getGuideIndex())
    data.addToCurLevelGuide(data.getGuideIndex())
    data.addToCurSuccessGuide(data.getGuideIndex())
    data.incSucceedGuideIndex(data.getGuideIndex())
    var [guideIndex, actionIndex] = [data.getGuideIndex(), data.getActionIndex()]
    data.resetRunningGuide()
    data.resetRunningAction()
    data.writeToFile()
    self.dispatchEvent(table(
        [1, "name", GameGuideEvents.EndAction],
        [1, "guideIndex", guideIndex],
        [1, "actionIndex", actionIndex]
    ))
    self.dispatchEvent(table(
        [1, "name", GameGuideEvents.EndGuide],
        [1, "guideIndex", guideIndex],
        [1, "actionIndex", actionIndex]
    ))
    data.setGuideIndex(index)
    if (data.getRunningGuide()) {
        data.setActionIndex(1)
        GameGuideRunner.runGuide(paras)
        self.dispatchEvent(table(
            [1, "name", GameGuideEvents.StartGuide],
            [1, "guideIndex", data.getGuideIndex()],
            [1, "actionIndex", data.getActionIndex()]
        ))
        self.dispatchEvent(table(
            [1, "name", GameGuideEvents.StartAction],
            [1, "guideIndex", data.getGuideIndex()],
            [1, "actionIndex", data.getActionIndex()]
        ))
    }
}
//是否需要显示二倍速的引导
GameGuide.prototype.checkDoubleSpeed = function(){
    return (1 != cc.UserDefault.getInstance().getStringForKey(LOCAL_GAMEBOARD_SPEED_SELECT_GUIDE, 0))
}
GameGuide.prototype.finishDoubleSpeed = function(){
    cc.UserDefault.getInstance().setStringForKey(LOCAL_GAMEBOARD_SPEED_SELECT_GUIDE, 1)
}
GameGuide.prototype.onRunReplayGuideWithOutOnceLimit = function (index, paras) {
    let self = this
    let data = GameGuideData.getInstance()
    if (!data.getRunningGuide()) {
        data.resetRunningGuide()
        return 
    }
    let guide = data.getGuideById(index)
    data.addToGameFlags("replay")
    if (!guide) { // or not GameGuideCheck:checkAppear(guide, paras, index) then
        cc.log("GameGuide onRunReplayGuideWithOutOnceLimit checkAppear false")
        return 
    }
    data.removeFromGameFlags("replay")
    GameGuideRunner.removeGuide(paras)
    let [guideIndex, actionIndex] = [data.getGuideIndex(), data.getActionIndex()]
    data.resetRunningGuide()
    data.resetRunningAction()
    self.dispatchEvent(table(
        [1, "name", GameGuideEvents.EndAction],
        [1, "guideIndex", guideIndex],
        [1, "actionIndex", actionIndex]
    ))
    self.dispatchEvent(table(
        [1, "name", GameGuideEvents.EndGuide],
        [1, "guideIndex", guideIndex],
        [1, "actionIndex", actionIndex]
    ))
    data.setGuideIndex(index)
    if (data.getRunningGuide()) {
        data.setActionIndex(actionIndex)
        GameGuideRunner.runGuide(paras)
        self.dispatchEvent(table(
            [1, "name", GameGuideEvents.StartGuide],
            [1, "guideIndex", data.getGuideIndex()],
            [1, "actionIndex", data.getActionIndex()]
        ))
        self.dispatchEvent(table(
            [1, "name", GameGuideEvents.StartAction],
            [1, "guideIndex", data.getGuideIndex()],
            [1, "actionIndex", data.getActionIndex()]
        ))
    } else if (guide.triggerClosed) {
        self.trigger(GameGuideTrigger.kGuideClosed, null)
    }
}
GameGuide.prototype.onViewChanged = function () {
    let self = this
    cc.log("GameGuide onViewChanged")
    if (self.isGuideRunning()) {
        let guideDataIdx = GameGuideData.getInstance().getGuideIndex()
        cc.log(string.format("GameGuide onViewChanged isGuideRunning %s", tostring(guideDataIdx)))
        self.onRunReplayGuideWithOutOnceLimit(guideDataIdx, self.m_currentTriggerParas)
    }
}
